export enum EnumGrantType {
    password = <any>"password",
    client_credentials = <any>"client_credentials",
    refresh_token = <any>"refresh_token",
    thirdparty_token = <any>"thirdparty_token",
    mfa = <any>"mfa"
}
